export const NOTIFICATIONS_LIST = "NOTIFICATIONS_LIST"
export const NOTIFICATIONS_LIST_SUCCESS = "NOTIFICATIONS_LIST_SUCCESS"
export const NOTIFICATIONS_LIST_ERROR = "NOTIFICATIONS_LIST_ERROR"

export const NOTIFICATIONS_NEW = "NOTIFICATIONS_NEW"
export const NOTIFICATIONS_NEW_SUCCESS = "NOTIFICATIONS_NEW_SUCCESS"
export const NOTIFICATIONS_NEW_ERROR = "NOTIFICATIONS_NEW_ERROR"

export const NOTIFICATIONS_USER_LIST = "NOTIFICATIONS_USER_LIST"
export const NOTIFICATIONS_USER_LIST_SUCCESS = "NOTIFICATIONS_USER_LIST_SUCCESS"
export const NOTIFICATIONS_USER_LIST_ERROR = "NOTIFICATIONS_USER_LIST_ERROR"

export const NOTIFICATIONS_GROUP_LIST = "NOTIFICATIONS_GROUP_LIST"
export const NOTIFICATIONS_GROUP_LIST_SUCCESS = "NOTIFICATIONS_GROUP_LIST_SUCCESS"
export const NOTIFICATIONS_GROUP_LIST_ERROR = "NOTIFICATIONS_GROUP_LIST_ERROR"
